import SiteDocHead from 'components/SiteDocHead/SiteDocHead'

export default SiteDocHead
